<template>
  <div>
    <div class="row">
      <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-12 pl-0">
        <div class="d-flex align-items-center">
          <button
            @click="handleStep('LANCAMENTO_POR_CATEGORIA')"
            :outlined="step != 'LANCAMENTO_POR_CATEGORIA'"
            :class="[
              step == 'LANCAMENTO_POR_CATEGORIA' && 'btn-nav-menu',
              step != 'LANCAMENTO_POR_CATEGORIA' && 'btn-nav-menu1',
            ]"
          >
            <strong>LANÇAMENTOS POR CATEGORIA</strong>
          </button>
          <div
            :class="[
              step == 'LANCAMENTO_POR_CATEGORIA' && 'triangulo-para-direita',
              step != 'LANCAMENTO_POR_CATEGORIA' && 'triangulo-none',
            ]"
          ></div>
        </div>
        <div class="d-flex align-items-center">
          <button
            @click="handleStep('LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO')"
            :outlined="step != 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO'"
            :class="[
              step == 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO' && 'btn-nav-menu',
              step != 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO' &&
                'btn-nav-menu1',
            ]"
          >
            <strong>LANÇAMENTOS POR CENTROS DE CUSTO/LUCRO</strong>
          </button>
          <div
            :class="[
              step == 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO' &&
                'triangulo-para-direita',
              step != 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO' &&
                'triangulo-none',
            ]"
          ></div>
        </div>
      </div>
      <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0">
        <div
          v-if="step == 'LANCAMENTO_POR_CATEGORIA'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <ReleasesByCategory />
        </div>
        <div
          v-if="step == 'LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <ReleasesByProfitCostCenter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReleasesByCategory from "./Reports/ReleasesByCategory";

import ReleasesByProfitCostCenter from "./Reports/ReleasesByProfitCostCenter";

import routes from "../../routes";

export default {
  name: "Reports",
  components: {
    ReleasesByCategory,
    ReleasesByProfitCostCenter,
  },
  data() {
    return {
      step: "LANCAMENTO_POR_CATEGORIA",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleStep(step) {
      let newMenu = {
        LANCAMENTO_POR_CATEGORIA: "releases-by-category",
        LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO: "releases-by-profit-cost-center",
      }[step];

      let { nav, menu } = routes.history.current.query;

      if (menu != newMenu) {
        routes.replace({ query: { nav, menu: newMenu } });
      }

      this.step = step;
    },
    retrieve() {
      const { nav, menu } = routes.history.current.query;

      if (menu) {
        let step = {
          "releases-by-category": "LANCAMENTO_POR_CATEGORIA",
          "releases-by-profit-cost-center":
            "LANCAMENTO_POR_CENTROS_DE_CUSTO_LUCRO",
        }[menu];

        this.step = step;
      } else {
        routes.replace({ query: { nav, menu: "reports" } });
      }
    },
  },
};
</script>
